import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Connects to data-controller="auto-refresh"
export default class extends Controller {
  static values = {
    interval: { type: Number, default: 30000 },
    url: String
  }

  connect() {
    if (this.hasUrlValue) {
      this.startRefreshing()
    }
  }

  disconnect() {
    this.stopRefreshing()
  }

  startRefreshing() {
    this.refreshTimer = setInterval(() => {
      this.refresh()
    }, this.intervalValue)
  }

  stopRefreshing() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }

  refresh() {
    // Reload the turbo frame
    const frame = this.element.closest("turbo-frame")
    if (frame && this.hasUrlValue) {
      frame.src = this.urlValue
      frame.reload()
    }
  }
}